import styled, { keyframes } from 'styled-components';

const zoomIn = keyframes`
  0% {
    transform: translateX(-20px); 
  }
  60% {
    transform: translateX(10px); 
  }
  100% {
    transform: translateX(0px); 
  }
`;

export const InputError = styled.div`
  margin-top: 0.4em;

  ${props => props.marginBottom && `
    margin-bottom: ${props.marginBottom}em;
  `}

  animation-duration: 0.3s;
  animation-name: ${zoomIn};
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;

  font-size: 0.725em;
  color: ${props => props.theme.dangerColor};
  font-family: ${props => props.theme.primaryFont};
`;